import ModelUtil from '@leverege/model-util'
import { ItemModel, TableModel } from '@leverege/ui-attributes'

const TYPE = 'ps.ShelfMonitoring'

function create() {

  let segments = ItemModel.create()
  segments = ItemModel.addType( segments, 'segment' )

  return {
    type : TYPE,
    segments,
    table : TableModel.create()
  }
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue( 'segments' ),
  ...ModelUtil.createAllValue( 'table' )
}
